export const store = {
    state: {
      flag: false
    },
    convert(value) {
      this.flag = value;
    }
  };


// WEBPACK FOOTER //
// ./src/store.js